import { render, staticRenderFns } from "./ClientsPagesContainer.vue?vue&type=template&id=728afe91&"
import script from "./ClientsPagesContainer.vue?vue&type=script&lang=js&"
export * from "./ClientsPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports